<template>
    <div>
        <el-card>
            <el-row>
                <el-col :span="24">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/KPI/Index' }">绩效管理</el-breadcrumb-item>
                        <el-breadcrumb-item>查看KPI评分</el-breadcrumb-item>
                    </el-breadcrumb>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-tabs v-model="activeName">
                <el-tab-pane label="月度" name="month">
                    <LookKPIScoreList :pt="0"></LookKPIScoreList>
                </el-tab-pane>
                <el-tab-pane label="季度" name="quarter">
                    <LookKPIScoreList :pt="1"></LookKPIScoreList>
                </el-tab-pane>
            </el-tabs>
        </el-card>
    </div>
</template>
<script>
import LookKPIScoreList from "../KPI/LookKPIScoreList";
export default {
  data() {
    return {
      activeName: "month",
    };
  },
  components: {
    LookKPIScoreList
  }
}
</script>
